import { render, staticRenderFns } from "./ContentDescriptionBlock.vue?vue&type=template&id=aefcd048&scoped=true&"
import script from "./ContentDescriptionBlock.vue?vue&type=script&lang=js&"
export * from "./ContentDescriptionBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aefcd048",
  null
  
)

export default component.exports